export default __webpack_public_path__ + "static/media/phoenix.c2196a9c.png";